import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import Header from "src/components/common/Header";
import SideBar from "src/components/common/SideBar";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";
import { useAppSelector } from "src/redux/store";
import NewEntityDashboard from "./NewEntityDashboard";

const DefaultLayout = () => {
  const styles = getStyles(defaultStyles);
  const user = useAppSelector((state) => state.root.user.data);
  const roleName = user?.role?.toLowerCase() || "";

  const isEntity = roleName.includes("entity");
  const isNew = user?.isNew;

  // if (isEntity && isNew === false) {
  //   // ✅ For new entity users
  //   return <NewEntityDashboard />;
  // }

  return (
    <>
        <Box {...styles("container")}>
          <SideBar />
          <Box {...styles("outletWrapper")}>
            <Header />
            <Box {...styles("outletContainer")}>
              <Outlet />
            </Box>
          </Box>
        </Box>
    </>
  );
};

export default DefaultLayout;
